import { useMutation, useQueryClient } from 'react-query'

import {
  type POBillToContactSystemPreference,
  SystemPreferenceKeys,
  SystemPreferencesRepository,
  systemPreferencesKeys,
} from '@webapp/platform/iam'

export const useMutatePOBillToContact = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (value: POBillToContactSystemPreference['value']) =>
      SystemPreferencesRepository.updateSystemPreference(
        SystemPreferenceKeys.PO_BILL_TO_CONTACT,
        value
      ),
    onSuccess: () => queryClient.invalidateQueries(systemPreferencesKeys.all),
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
